<script>
import ClientCard from "./ClientCard.vue";
import Button from "@/shared/ui/button/Button.vue";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import { getParticipantListRecent } from "@/entities/transaction/api";

export default {
  name: "ClientsInOffice",
  components: {
    ClientCard,
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
  },
  data() {
    return {
      selectedAction: "quick_action",
      actions: [
        {
          label: this.$t("Быстрое действие"),
          action: "quick_action",
        },
      ],
      currentPage: 1,
      columnsPerRow: 3,
      clients: [],
      totalClients: 0,
    };
  },
  computed: {
    selectedActionTitle() {
      let action = this.actions.find(
        (item) => item.action === this.selectedAction
      );
      return action ? action.label : "";
    },
    itemsPerPage() {
      return this.columnsPerRow * 2;
    },
    totalPages() {
      return Math.ceil(this.clients.length / this.itemsPerPage);
    },
    paginatedClients() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.clients.slice(start, end);
    },
  },
  mounted() {
    this.fetchClients();
    this.updateColumns();
    window.addEventListener("resize", this.updateColumns);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateColumns);
  },
  methods: {
    async fetchClients() {
      const { success, payload } = await getParticipantListRecent();

      if (success && payload?.items?.length) {
        this.clients = payload.items || [];
        this.totalClients = payload.total || 0;
      }
    },
    updateColumns() {
      const width = window.innerWidth;
      if (width > 1500) {
        this.columnsPerRow = 3;
      } else if (width > 1100) {
        this.columnsPerRow = 2;
      } else {
        this.columnsPerRow = 1;
      }
      if (this.currentPage > this.totalPages && this.totalPages > 0) {
        this.currentPage = this.totalPages;
      }
    },
    changeAction(action) {
      this.selectedAction = action;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
  },
};
</script>

<template>
  <div class="main">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <p class="text-lg leading-6 font-semibold text-foreground">
          {{ $t("Клиенты") }}
        </p>
        <span class="text-lg leading-6 text-muted-foreground">{{
          totalClients
        }}</span>
      </div>

      <!--      <DropdownMenu>-->
      <!--        <DropdownMenuTrigger as-child>-->
      <!--          <Button variant="outline" size="lg">-->
      <!--            {{ selectedActionTitle }}-->
      <!--            <el-icon class="el-icon&#45;&#45;right"><arrow-down /></el-icon>-->
      <!--          </Button>-->
      <!--        </DropdownMenuTrigger>-->
      <!--        <DropdownMenuContent>-->
      <!--          <DropdownMenuItem-->
      <!--            v-for="item in actions"-->
      <!--            :key="item.action"-->
      <!--            @click="changeAction(item.action)"-->
      <!--          >-->
      <!--            {{ item.label }}-->
      <!--          </DropdownMenuItem>-->
      <!--        </DropdownMenuContent>-->
      <!--      </DropdownMenu>-->
    </div>

    <div class="flex flex-1 gap-4 items-center">
      <Button
        v-if="totalPages > 1"
        variant="outline"
        @click="prevPage"
        :disabled="currentPage === 1"
        class="arrow cursor-pointer shrink-0"
      >
        <svg-icon name="huge-chevron-left" class="w-6 h-6" />
      </Button>

      <div class="clients">
        <ClientCard
          v-for="(client, index) in paginatedClients"
          :key="index"
          :client="client"
        />
      </div>

      <Button
        v-if="totalPages > 1"
        variant="outline"
        @click="nextPage"
        :disabled="currentPage >= totalPages"
        class="arrow cursor-pointer shrink-0"
      >
        <svg-icon name="huge-chevron-right" class="w-6 h-6" />
      </Button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.main {
  @apply flex flex-col py-6 gap-6 bg-card rounded-2xl;

  .clients {
    @apply w-full flex-1 grid gap-5;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, auto);

    @media (max-width: 1500px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 1100px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .arrow {
    @apply w-6 h-6 flex justify-center items-center cursor-pointer;
  }
}
</style>
